import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscriber } from 'rxjs';
import { BondHelpers } from './bondHelpers';
import { takeUntil } from 'rxjs/operators';
import { GlobalState } from '../global.state';
import { MarketDataService } from '../globalData';
import { FormGroup } from '@angular/forms';
import { EVENT_NAMES } from './enums';
import { GenericError } from './dataInterfaces';
import { Util } from './util.service';

@Injectable()
export class TreasuryRatesUtil {

  private readonly onDestroy: Subject<void> = new Subject<void>();
  treasuryRates: any;
  retrievingTreasuryRates: boolean = true;
  treasuryDataError: boolean;

  constructor( private _state: GlobalState, private _mdService: MarketDataService ) {
    this.getTreasuryRates();

    if ( Util.isNotProd() ) {
      Util.addComponentToWindow( this, 'treasuryRatesUtil' );
    }
  }

  /**
   * returns the treasury rate for the given maturity date. if the treasury rates have not been retrieved yet, it will
   * retrieve them and return the rate for the given maturity date.
   * @param form - form group that has a control named maturity_date to get the ttm date
   */
  figureOutTTMMatchedRate( form: FormGroup ): Observable<number> {
    return new Observable( ( observer: Subscriber<number> ): void => {
      const rates: any = this.treasuryRates;
      if ( rates ) {
        const treasury_rate: any = BondHelpers.geTimeToMaturityMatchedTreasuryRateInPercent( form.controls.maturity_date.value, rates );
        observer.next( treasury_rate );
      } else {
        this.retrievingTreasuryRates = true;
        this._mdService.getTreasuryRates()
          .pipe( takeUntil( this.onDestroy ) )
          .subscribe( {
            next: ( resp: any ): void => {
              // console.log( resp );
              this.treasuryRates = resp.data;
              this._state.notifyDataChanged( EVENT_NAMES.TREASURIES_RETRIEVED );
              const treasury_rate: number = BondHelpers.geTimeToMaturityMatchedTreasuryRateInPercent( form.controls.maturity_date.value, this._state.globalVars.treasuryRates );
              this.retrievingTreasuryRates = false;
              observer.next( treasury_rate );
            }, error: ( err: GenericError ): void => {
              observer.error( err );
            },
          } );
      }
    } );
  }

  /**
   * Fetches the treasury rates and updates the component's state with the retrieved data.
   * This method makes an API call to retrieve treasury rates and handles success
   * and error responses accordingly. It notifies the application*/
  getTreasuryRates(): void {
    this.retrievingTreasuryRates = true;
    this._mdService.getTreasuryRates()
      .pipe( takeUntil( this.onDestroy ) )
      .subscribe( {
        next: ( resp: any ): void => {
          // console.log( resp );
          this.treasuryRates = resp.data;
          this.treasuryDataError = false;
          this.retrievingTreasuryRates = false;
          this._state.notifyDataChanged( EVENT_NAMES.TREASURIES_RETRIEVED );
        }, error: ( err: GenericError ): void => {
          console.error( err );
          this.treasuryDataError = true;
          this.retrievingTreasuryRates = false;
          this._state.notifyDataChanged( EVENT_NAMES.ERROR_RETRIEVING_TREASURY_DATA );
        },
      } );
  }

}
